import React, { useState } from "react";
import liracrypt from "../components/Liracrypt/liracrypt";
import SessionError from "../components/ApiErrorComp/SessionError";
import ApiErrorComp from "../components/ApiErrorComp/ApiErrorComp";
import { LoadingOutlined } from "@ant-design/icons";
import {
  Spin,
  Button,
  Row,
  Col,
  notification,
  Form,
  message,
  Input,
  InputNumber,
} from "antd";

import CropDown from "../components/ReportFormGenerator/CropDown/CropDown";
import moment from "moment";
import UniDropAdv from "../components/ReportFormGenerator/UniDrop/UniDropAdv";
import reactLogo from "../images/reactLogo2.png";
import flaskLogo from "../images/flask1.png";

// import Button from "../components/ReportFormGenerator/Button/Button";
//Update React Version Here

const d = moment(new Date()).format("YYYYMMDD-HHMM").toString();

//version.js 
// test01\

const version = "20260408 11:35 KS";

const antIcon = <LoadingOutlined style={{ fontSize: 36 }} spin />;


function VersionPage({ setPageHeader }) {
  setPageHeader("Lira Admin");

  const [form] = Form.useForm();
  const [emailForm] = Form.useForm();
  const [phForm] = Form.useForm();
  const [form1] = Form.useForm();
  const [dynamicViewForm] = Form.useForm();
  const [mdictData, setMdictData] = useState();
  const [loginError, setLoginError] = React.useState(false);
  const [flaskVersion, setFlaskVersion] = React.useState("");
  const [mount, setMount] = React.useState(false);

  const [loading, setLoading] = React.useState(false);
  const [mloading, setMLoading] = React.useState(false);
  const [viewFormLoading, setViewFormLoading] = React.useState(false);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message,
    });
  };

  React.useEffect(() => {
    liracrypt
      .get("/version", {})
      .then((res, req) => {
        setFlaskVersion(res.data.data);
        setMount(true);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  }, []);

  const clicked = () => {
    setLoading(true);
    liracrypt
      .get("/update/superdict", {})
      .then((res, req) => {
        openNotificationWithIcon("success", res.data.message);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const masterClicked = (v) => {
    setMLoading(true);
    liracrypt
      .post("/masterdicts", v)
      .then(({ data }) => {
        setMdictData(data.data);
        openNotificationWithIcon("success", data.message);
        setMLoading(false);
      })

      .catch((err) => {
        setMLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const dynamicViewFinish = (v) => {
    setViewFormLoading(true);
    liracrypt
      .post("/test", v)
      .then((res, req) => {
        openNotificationWithIcon("success", res.data.message);
        setViewFormLoading(false);
      })

      .catch((err) => {
        setViewFormLoading(false);
        if (err.response !== undefined) {
          if (err.response.status !== 401) {
            ApiErrorComp(err.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const onFinish = (v) => {};

  const dataValidation = () => {
    liracrypt
      .get("/start/batfile", {})
      .then(({ data }) => {
        if (data.isSuccess) {
          message.success(data.message || "Successfull");
        } else {
          message.error(data.message || "Error");
        }
      })
      .catch((err) => {
        ApiErrorComp();
      });
  };

  const sendEmail = (values) => {
    liracrypt
      .post("/admin/mail", { ...values })
      .then(({ data }) => {
        if (data.isSuccess) {
          message.success(data.message || "Successfull");
        } else {
          message.error(data.message || "Error");
        }
      })
      .catch((err) => {
        ApiErrorComp();
      });
  };

  const sendSMS = (values) => {
    liracrypt
      .post("/test", { ...values })
      .then(({ data }) => {
        if (data.isSuccess) {
          message.success(data.message || "Successfull");
        } else {
          message.error(data.message || "Error");
        }
      })
      .catch((err) => {
        ApiErrorComp();
      });
  };

  return (
    <>
      <SessionError visible={loginError} />
      <div
        style={{
          // flex: 1,
          width: "100%",
          fontSize: "40px",
          backgroundColor: "#f1c40f",
        }}
      >
        charlie
      </div>
      <div style={{ width: "100%" }}></div>
      <br></br>
      <br></br>
      <br></br>
      <div
        style={{
          flex: 1,
          display: "flex",
          minHeight: "40vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {mount ? (
          <>
            <div
              style={{
                // flex: 1,
                backgroundColor: "#3b3b3b",
                width: "30%",
                display: "inline-block",
                padding: "10px",
                borderRadius: "10px",
                margin: "10px",
              }}
            >
              <table>
                <tr>
                  <td>
                    <img
                      src={reactLogo}
                      alt="ReactLogo"
                      width="125"
                      height="100"
                    />
                  </td>
                  <td>
                    <h3
                      style={{
                        fontSize: "15px",
                        marginTop: "10px",
                        color: "#2ecc71",
                        fontWeight: 700,
                      }}
                    >
                      React Version
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div style={{ textAlign: "center" }}>
                      <h1
                        style={{
                          fontSize: "30px",
                          color: "#2ecc71",
                          fontWeight: 700,
                        }}
                      >
                        {version}
                      </h1>
                    </div>
                  </td>
                </tr>
              </table>
            </div>

            <div
              style={{
                // flex: 1,
                backgroundColor: "#3b3b3b",
                width: "30%",
                display: "inline-block",
                padding: "10px",
                borderRadius: "10px",
                margin: "10px",
              }}
            >
              <table>
                <tr>
                  <td>
                    <img
                      src={flaskLogo}
                      alt="ReactLogo"
                      width="100"
                      height="100"
                    />
                  </td>
                  <td>
                    <h3
                      style={{
                        fontSize: "15px",
                        marginTop: "10px",
                        color: "#007bff",
                        fontWeight: 700,
                      }}
                    >
                      Flask Version
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div style={{ textAlign: "center" }}>
                      <h1
                        style={{
                          fontSize: "30px",
                          color: "#007bff",
                          fontWeight: 700,
                        }}
                      >
                        {flaskVersion}
                      </h1>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </>
        ) : (
          <>
            <Spin indicator={antIcon} />
          </>
        )}
      </div>
      <br></br>
      <br></br>
      <br></br>
      <div
        style={{
          borderTop: "3px solid #2ecc71 ",
          marginLeft: 0,
          marginRight: 0,
        }}
      ></div>

      <Row gutter={12} justify="center">
        <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
          <div className="ThemeForm">
            <Form
              form={form1}
              onFinish={masterClicked}
              layout="horizontal"
              colon={false}
              size="large"
            >
              <table alignItems="center">
                <tr>
                  <td>
                    {" "}
                    <UniDropAdv
                      form={form}
                      colSpan={24}
                      multiSelect={false}
                      url={"/cropdown"}
                      disabled={false}
                      source={"cropdown"}
                      urlData={{ name: "UpdateMasterDict" }}
                      pname={"typ"}
                      name={"typ1"}
                      label={"Type"}
                      errorMessage={"Please Select Type !"}
                      required={true}
                      placeholder={"Select Type"}
                      defaultValue={null}
                      searchable={true}
                      includeAll={true}
                    />
                  </td>
                  <td>
                    {" "}
                    <Row gutter={24} justify="center">
                      <Col span={24}>
                        <Form.Item
                          className="formBtnGroup"
                          colon={false}
                          style={{
                            marginTop: "0",
                            marginLeft: "65px",
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            id="submitButtonForm"
                            style={{ marginLeft: "-50px", fontWeight: 700 }}
                            loading={mloading}
                            type="primary"
                            htmlType="submit"
                          >
                            Update MasterDict
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </td>
                </tr>
              </table>
            </Form>
          </div>
        </div>
      </Row>

      {mdictData ? (
        <Row justify={"center"}>
          <Col span={12} style={{ border: "1px solid #9c9c9c" }}>
            <p
              style={{
                borderBottom: "1px solid #9c9c9c",
                fontSize: 25,
                color: "#9c9c9c",
              }}
            >
              List Failure
            </p>
            <ul style={{ maxHeight: 300, overflow: "auto" }}>
              {mdictData.listFailure.map((x, i) => (
                <li
                  style={{ fontSize: 20, color: "#9c9c9c" }}
                  key={`mdict-listfail-${i}`}
                >
                  {x}
                </li>
              ))}
            </ul>
          </Col>
          <Col span={12} style={{ border: "1px solid #9c9c9c" }}>
            <p
              style={{
                borderBottom: "1px solid #9c9c9c",
                fontSize: 25,
                color: "#9c9c9c",
              }}
            >
              List Success
            </p>
            <ul style={{ maxHeight: 300, overflow: "auto" }}>
              {mdictData.listSuccess.map((x, i) => (
                <li
                  style={{ fontSize: 20, color: "#9c9c9c" }}
                  key={`mdict-listSuccess-${i}`}
                >
                  {x}
                </li>
              ))}
            </ul>
          </Col>
        </Row>
      ) : (
        <></>
      )}

      {/* Create View Dynamic Form */}

      <Row gutter={12} justify="center">
        <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
          <div className="ThemeForm">
            <Form
              form={dynamicViewForm}
              onFinish={dynamicViewFinish}
              layout="horizontal"
              colon={false}
              size="large"
            >
              <table alignItems="center">
                <tr>
                  <td>
                    {" "}
                    <UniDropAdv
                      form={dynamicViewForm}
                      colSpan={24}
                      multiSelect={false}
                      url={"/dynamicdropdown"}
                      disabled={false}
                      source={"dynamic"}
                      urlData={{ name: "ZenFormConfig" }}
                      pname={"p_viewName"}
                      name={"viewName"}
                      label={"Name"}
                      errorMessage={"Please Select Name !"}
                      required={true}
                      placeholder={"Select Name"}
                      defaultValue={null}
                      searchable={true}
                      includeAll={true}
                    />
                  </td>
                  <td>
                    {" "}
                    <Row gutter={24} justify="center">
                      <Col span={24}>
                        <Form.Item
                          className="formBtnGroup"
                          colon={false}
                          style={{
                            marginTop: "0",
                            marginLeft: "65px",
                            justifyContent: "center",
                          }}
                        >
                          <Button
                            id="submitButtonForm"
                            style={{ marginLeft: "-50px", fontWeight: 700 }}
                            loading={viewFormLoading}
                            type="primary"
                            htmlType="submit"
                          >
                            Create Dynamic View
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                  </td>
                </tr>
              </table>
            </Form>
          </div>
        </div>
      </Row>

      {/* Create View Dynamic Form */}

      <Row gutter={24} justify="center">
        <div style={{ paddingRight: "20px" }}>
          <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
            <div className="ThemeForm">
              <Form
                form={form}
                onFinish={clicked}
                layout="horizontal"
                colon={false}
                size="large"
              >
                <Row gutter={24} justify="left">
                  <Col span={24}>
                    <Form.Item
                      className="formBtnGroup"
                      colon={false}
                      style={{
                        marginTop: "20px",
                        marginLeft: "65px",
                        justifyContent: "center",
                      }}
                    >
                      <Button
                        id="submitButtonForm"
                        style={{ marginLeft: "-37px", fontWeight: 700 }}
                        loading={loading ? loading : false}
                        type="primary"
                        htmlType="submit"
                      >
                        Update SuperDict
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </Row>

      <div
        style={{
          width: "100%",
          display: "inline-flex",
          justifyContent: "center",
        }}
      >
        <Button onClick={dataValidation} type="primary" size="large">
          Data Validation
        </Button>
      </div>

      <div
        className={`AuditSection CreateAudit`}
        style={{
          padding: "10px",
          border: "1px solid #9C9C9C",
          borderRadius: 10,
          marginTop: 20,
        }}
      >
        <h2 style={{ color: "#ffffff", textAlign: "center" }}>Send Email</h2>
        <div className={`ThemeForm ${"phantom"}-form`}>
          <Form
            name={`ReportForm `}
            form={emailForm}
            labelWrap={true}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={sendEmail}
            size="large"
          >
            <Row justify={"center"}>
              <Col span={16}>
                <Form.Item
                  name="email"
                  label="Email"
                  rules={[{ required: true }]}
                >
                  <Input type="email" />
                </Form.Item>
              </Col>
              <Col span={16}>
                <Form.Item
                  name="remark"
                  label="Remark"
                  rules={[{ required: true }]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col
                span={16}
                style={{ justifyContent: "center", display: "flex" }}
              >
                <Button htmlType="submit" type="primary" size="large">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>

      <div
        className={`AuditSection CreateAudit`}
        style={{
          padding: "10px",
          border: "1px solid #9C9C9C",
          marginTop: 20,
          borderRadius: 10,
        }}
      >
        <h2 style={{ color: "#ffffff", textAlign: "center" }}>Send SMS</h2>
        <div className={`ThemeForm ${"phantom"}-form`}>
          <Form
            name={`ReportForm `}
            form={phForm}
            labelWrap={true}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={sendSMS}
            size="large"
          >
            <Row justify={"center"}>
              <Col span={16}>
                <Form.Item
                  name="phNo"
                  label="Phone Number"
                  rules={[{ required: true }]}
                >
                  <InputNumber
                    minLength={10}
                    maxLength={10}
                    style={{ width: "100%" }}
                    size={"large"}
                  />
                </Form.Item>
              </Col>
              <Col span={16}>
                <Form.Item
                  name="remark"
                  label="Remark"
                  rules={[{ required: true }]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col
                span={16}
                style={{ justifyContent: "center", display: "flex" }}
              >
                <Button type="primary" size="large">
                  Submit
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
}

export default VersionPage;
